import { applyMiddleware, compose, createStore } from 'redux';
import { thunk } from 'redux-thunk';

import rootReducer from 'apps/auth/reducers';

export default function getStore(initState) {
    const devtoolsCompose = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    const composeEnhancers = !__isProd__ && devtoolsCompose ? devtoolsCompose({ trace: true, traceLimit: 25 }) : compose;
    const middlewareEnhancer = composeEnhancers(applyMiddleware(thunk));
    return createStore(rootReducer, initState, middlewareEnhancer);
}
